export const useMenuItemsStatus = (): Record<string, string> => {
  // No menu items require status tracking after IFO removal
  return {}
}
